// extracted by mini-css-extract-plugin
export default {"description":"style_description__jAPf7","fade-in":"style_fade-in__+elZY","top":"style_top__bC5TG","image":"style_image__sfX0k"};